import React, { Component } from "react";
import Avatar from "react-avatar";
import { connect } from "react-redux";
import _ from "lodash";
import { bindActionCreators } from "redux";
import Select from 'react-select';
import moment from 'moment';
import {
  InputGroup,
  Form,
  Button,
  Accordion
} from "react-bootstrap";
import { ChevronRightIcon, ChevronDownIcon } from "@heroicons/react/outline";
import { removeWishDetail, updateWish, addWishDetail, getWishDetail } from "../../actions/wishs";
import CamelVoted from "../../assets/images/icon-camel-filled.svg";
import "./WishItemDetail.scss";

const statusOptions = [
  { value: 'Wished', label: 'Wished'},
  { value: 'In progress', label: 'In progress' },
  { value: 'Closed', label: 'Closed' },
  { value: 'Fulfilled', label: 'Fulfilled' },
  { value: 'Rejected', label: 'Rejected' },
];

const selectStyles = (width) => {
  return {
    control: styles => ({
      ...styles,
      backgroundColor: 'white',
      height: 32,
      width,
      minHeight: 20,
      marginRight: 10
    }),
  }
};

class Wishlist extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpenRequstedBy: false,
      isOpenRelatedTo: false,
      funnelStage: null,
      contentType: null,
      wishStatus: null,
      statusNote: '',
      error: null,
      isNextAvailable: true
    }
  }

  componentDidMount() {
    // From willMount
    const isAdmin = _.get(this.props, "cognitoUser.attributes['custom:role']") === 'admin';
    const wishId = _.get(this.props, 'match.params.wishId', 'null');
    this.props.getWishDetail(wishId);

    if (!isAdmin) {
      this.props.history.push('/dashboard');
    }
    //////
  }

  static getDerivedStateFromProps(props, state) {
    if (props.detail && props.detail.contentType) {
      return {
        ...state,
        contentType: {
          value: props.detail.contentType,
          label: props.detail.contentType
        }
      };
    }

    if (props.detail && props.detail.funnelStage) {
      return {
        ...state,
        funnelStage: {
          value: props.detail.funnelStage,
          label: props.detail.funnelStage
        }
      };
    }

    if (props.wishs) {
      const wishId = _.get(props, 'match.params.wishId', 'null')
      const findIndex = props.wishs.findIndex(w => w.id === wishId);
      if (props.wishs[findIndex + 1]) {
        return {
          ...state,
          isNextAvailable: true
        };
      } else {
        return {
          ...state,
          isNextAvailable: false
        };
      }
    }

    return state;
  }

  componentWillUnmount() {
    const wishId = _.get(this.props, 'match.params.wishId', 'null')
    this.props.removeWishDetail(wishId);
  }

  handleGridChange = (value) => {
  }

  closeWish = () => {
    // const wishId = _.get(this.props, 'match.params.wishId', 'null');
    // const params = {
    //   ...this.props.detail,
    //   status: 'Closed'
    // };

    // delete params.upvotedBy;
    // delete params.requestedByAvatar;

    // this.props.updateWish(wishId, params);
    // this.props.removeWishDetail(wishId);
    this.props.history.push('/wishlist');
  }

  updateWishStatus = () => {
    if (!this.state.wishStatus) {
      this.setState({ error: 'Please select status.' });
      return;
    }

    this.setState({ error: null });

    const wishId = _.get(this.props, 'match.params.wishId', 'null');
    const params = {
      ...this.props.detail,
      contentType: this.state.contentType.value,
      status: this.state.wishStatus.value,
      statusNote: this.state.statusNote
    };

    delete params.upvotedBy;
    delete params.requestedByAvatar;

    this.props.updateWish(wishId, params);

    this.props.removeWishDetail(wishId);
    this.props.history.push('/wishlist');
  }

  gotoNextWish = () => {
    const wishId = _.get(this.props, 'match.params.wishId', 'null');
    const findIndex = this.props.wishs.findIndex(w => w.id === wishId);

    if (findIndex >= 0 && this.props.wishs[findIndex + 1]) {
      this.props.addWishDetail(this.props.wishs[findIndex + 1].id);
      this.props.history.push(`/wish/detail/${this.props.wishs[findIndex + 1].id}`);
      this.props.removeWishDetail(wishId);
    }
  }

  render() {
    const {
      isOpenRequstedBy,
      isOpenRelatedTo,
      // funnelStage,
      contentType,
      wishStatus,
      statusNote
    } = this.state;

    const { contentTypes } = this.props.settings;

    const contentTypeOptions = Object.keys(contentTypes).map(key => ({
      value: key,
      label: key
    }));

    // const isAdmin = _.get(this.props, "cognitoUser.attributes['custom:role']") === 'admin';

    return (
      <div className="wish-item-detail-container">
        <div className="filter-sidebar">
          <Accordion defaultActiveKey="0">
            <Accordion.Toggle
              eventKey="0"
              className="w-100 accordion-toggle"
              onClick={() => this.setState({ isOpenRequstedBy: !isOpenRequstedBy })}
            >
              <div className="title d-flex">
                <span>Requested By</span>
                {isOpenRequstedBy ? <ChevronDownIcon className="icons" /> : <ChevronRightIcon className="icons" />}
              </div>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="0">
              <div className="d-flex requested-by">
                <Avatar
                  name={_.get(this.props.detail, 'requestedByName', '')}
                  size={40}
                  round={true}
                  color="#63b3ed"
                  fgColor="white"
                  className="mr-2"
                  src={_.get(this.props.detail, 'requestedByAvatar.medium', null)}
                />
                <div className="ml-2">
                  <p>{_.get(this.props.detail, 'requestedByName', '')}</p>
                  <p>Team Member</p>
                </div>
              </div>
            </Accordion.Collapse>
          </Accordion>
          <Accordion defaultActiveKey="1">
            <Accordion.Toggle
              eventKey="1"
              className="w-100 accordion-toggle top-border"
              onClick={() => this.setState({ isOpenRelatedTo: !isOpenRelatedTo })}
            >
              <div className="title d-flex">
                <span>Content Details</span>
                {isOpenRelatedTo ? <ChevronDownIcon className="icons" /> : <ChevronRightIcon className="icons" />}
              </div>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="1">
              <div className="d-flex related-to">
                {/* <p>Funnel Stage</p>
                <Select
                  options={funnelOptions}
                  styles={selectStyles(200)}
                  placeholder="Content Type"
                  className="selector"
                  value={funnelStage}
                  onChange={(e, value, action) => this.setState({ funnelStage: e })}
                /> */}
                <p>Content Type</p>
                <Select
                  options={contentTypeOptions}
                  styles={selectStyles(200)}
                  placeholder="Content Type"
                  className="selector"
                  value={contentType}
                  onChange={(e, value, action) => this.setState({ contentType: e })}
                />
              </div>
            </Accordion.Collapse>
          </Accordion>
        </div>
        <div className="detail-wrapper">
          <p className="wish-detail-title">Wish Details</p>
          <div className="wish-state">{_.get(this.props.detail, 'status', '')}</div>
          <p className="sub-title">Title</p>
          <p className="sub-description">{_.get(this.props.detail, 'title', '')}</p>
          <p className="sub-title">Details or Description</p>
          <p className="sub-description">{_.get(this.props.detail, 'description', '')}</p>
          <p className="sub-title">Why is useful</p>
          <p className="sub-description">{_.get(this.props.detail, 'why', '')}</p>
          <p className="sub-title">Revenue</p>
          <p className="sub-description revenue">{_.get(this.props.detail, 'revenueImpact', '')}</p>
          <div className="wish-state-details">
            <div className="d-flex upvotes">
              <img 
                src={CamelVoted}
                className="mr-2"
                alt="camel"
                id={true ? 'btnWishlistCardUnupvote' : 'btnWishlistCardUpvote'}
              />
              <span>{_.get(this.props.detail, 'upvoteCount', 0)}</span>
            </div>
            <div className="created-date">{moment(_.get(this.props.detail, 'createdAt', 0)).fromNow()}</div>
          </div>
          <div className="border-divider"></div>
          <div className="actions">
            <div className="btn-wish-action" onClick={this.closeWish}>Close Wish</div>
            {this.state.isNextAvailable && <div className="btn-wish-action" onClick={this.gotoNextWish}>Next Wish</div>}
          </div>
        </div>
        <div className="wish-editor-wrapper">
          <p className="main-title">Update Status</p>
          <Select
            options={statusOptions}
            styles={selectStyles(200)}
            placeholder="Status"
            className="selector"
            value={wishStatus}
            onChange={(e, value, action) => this.setState({ wishStatus: e })}
          />
          <InputGroup className="mb-3 mt-3">
            <Form.Control
              as="textarea"
              rows="5"
              placeholder="Notes"
              value={statusNote}
              onChange={(e) => this.setState({ statusNote: e.target.value })}
            />
          </InputGroup>
          {this.state.error && <p className="error">{this.state.error}</p>}
          <div className="status-actions">
            <Button variant="outline-danger mt-3" size="sm" onClick={this.updateWishStatus}>UPDATE</Button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  cognitoUser: state.auth.cognitoUser,
  settings: state.settings,
  detail: (state.wishlist.wishDetails || []).find(it => it.id === _.get(ownProps, 'match.params.wishId', {})),
  wishs: state.wishlist.wishs
});

const mapDispatchToProps = dispatch => 
bindActionCreators({
  removeWishDetail,
  updateWish,
  addWishDetail,
  getWishDetail
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Wishlist);
